<template>
  <div class="text-block flex flex-col space-y-4 text-gray-600">
    <lf-text-editor
      :value="modelValue.title ?? ''"
      name="text-block-title"
      content-type="html"
      :toolbar="[{ size: [false, 'small', 'large', 'huge'] }]"
      :placeholder="t('COMMON.TITLE')"
      :disabled="disabled"
      data-cy="text-block-title-editor"
      class="rounded-md border border-gray-200"
      pure-markup
      @update:content="(value: string) => handleTextFieldUpdate('title', value)"
    />
    <lf-text-editor
      :value="modelValue.description ?? ''"
      name="text-block-description"
      content-type="html"
      :placeholder="t('COMMON.DESCRIPTION')"
      :disabled="disabled"
      data-cy="text-block-description-editor"
      class="rounded-md border border-gray-200"
      pure-markup
      @update:content="
        (value: string) => handleTextFieldUpdate('description', value)
      "
    />
  </div>
</template>

<script setup lang="ts">
import { toRef } from "vue";
import { useI18n } from "vue-i18n";

import { useBlockEdit } from "@/composables/useBlockEdit";

import LfTextEditor from "@/components/ui/LfTextEditor.vue";

import type { BaseBlockProps } from "@/models/borrowerPlatformTemplates";
import type { Block } from "@/models/borrowerPlatformTemplates";

const { modelValue, disabled = false } = defineProps<
  BaseBlockProps & {
    disabled?: boolean;
  }
>();

const { t } = useI18n();
const { updateBlock } = useBlockEdit(toRef(() => modelValue));

const handleTextFieldUpdate = (field: keyof Block, value: string) => {
  if (disabled) {
    return;
  }
  updateBlock(field, value);
};
</script>

<style scoped>
:deep(.ql-editor) {
  height: 80px !important;
  min-height: 80px !important;
}

:deep(.ql-container) {
  height: 80px !important;
  min-height: 80px !important;
}
</style>
